module.exports = "/images/mv_bg_03.png?ac7a4724b850829a32c74ade7c33b3b9";